import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, Input, Inject, PLATFORM_ID, HostBinding } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { delay, filter, take, takeUntil } from 'rxjs/operators';

import { FuseConfigService } from './../../../../../../@fuse/services/config.service';
import { FuseNavigationService } from './../../../../../../@fuse/components/navigation/navigation.service';
// tslint:disable-next-line:max-line-length
import { FusePerfectScrollbarDirective } from './../../../../../../@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from './../../../../../../@fuse/components/sidebar/sidebar.service';
import { isPlatformBrowser } from '@angular/common';
import { ShellDomainProvider, EcapLoginService } from '@ecap3/core';
import { TemplateAtlasSharedService } from '../../../../../../ecap/shared.services';
import { EcapBroadcastService } from './../../../../../../ecap/services/ecap-broadcast.service';
@Component({
    selector: 'navbar-vertical-style-2',
    templateUrl: './style-2.component.html',
    styleUrls: ['./style-2.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NavbarVerticalStyle2Component implements OnInit, OnDestroy {
    @HostBinding('class.is-preview-open') isPreviewOpen;
    @HostBinding('class.is-preview-close') isPreviewClose;
    @Input() userInfo: any;
    //@ViewChild('authFormLogout') authFormLogout;
    fuseConfig: any;
    navigation: any;
    currentDomain: string;
    currentDomainWithoutProtocol: string;
    basicUserInfo: any;
    showReportIssueMenu = false;
    // Private
    private _fusePerfectScrollbar: FusePerfectScrollbarDirective;
    private _unsubscribeAll: Subject<void>;

    /**
     * Constructor
     *
     * param {FuseConfigService} _fuseConfigService
     * param {FuseNavigationService} _fuseNavigationService
     * param {FuseSidebarService} _fuseSidebarService
     * param {Router} _router
     */
    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private _fuseConfigService: FuseConfigService,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseSidebarService: FuseSidebarService,
        private _router: Router,
        private templateAtlasSharedService: TemplateAtlasSharedService,
        private loginService: EcapLoginService,
        private ecapBroadcastService: EcapBroadcastService,
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    // Directive
    @ViewChild(FusePerfectScrollbarDirective,{static:true})
    set directive(theDirective: FusePerfectScrollbarDirective) {
        if (!theDirective) {
            return;
        }

        this._fusePerfectScrollbar = theDirective;

        // Update the scrollbar on collapsible item toggle
        this._fuseNavigationService.onItemCollapseToggled
            .pipe(
                delay(500),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this._fusePerfectScrollbar.update();
            });

        // Scroll to the active item position
        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                take(1)
            )
            .subscribe(() => {
                setTimeout(() => {
                    const activeNavItem: any = document.querySelector('navbar .nav-link.active');

                    if (activeNavItem) {
                        const activeItemOffsetTop = activeNavItem.offsetTop,
                            activeItemOffsetParentTop = activeNavItem.offsetParent.offsetTop,
                            scrollDistance = activeItemOffsetTop - activeItemOffsetParentTop - (48 * 3);

                        this._fusePerfectScrollbar.scrollToTop(scrollDistance);
                    }
                });
            }
            );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        TemplateAtlasSharedService.getChangePreview()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(data => {
                this.isPreviewOpen = data;
            });

        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                if (this._fuseSidebarService.getSidebar('navbar')) {
                    this._fuseSidebarService.getSidebar('navbar').close();
                }
            }
            );

        // Get current navigation
        this._fuseNavigationService.onNavigationChanged
            .pipe(
                filter(value => value !== null),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this.navigation = this._fuseNavigationService.getCurrentNavigation();
            });

        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.fuseConfig = config;
                // this.userInfo.ProfileImage = this.userInfo.ProfileImage || this.fuseConfig.layout.navbar.userProfileDefaultImage;
                this.userInfo.ProfileImage = this.userInfo.ProfileImage;
            });

        this.ecapBroadcastService.onUserInfoEvent().subscribe((userInfo) => {
            this.userInfo = userInfo;

            const { FirstName, LastName, DisplayName } = userInfo;

            if (!DisplayName) {
                let fullName = '';
                if (FirstName && LastName) {
                    fullName = FirstName + ' ' + LastName;
                } else if (FirstName && !LastName) {
                    fullName = FirstName;
                } else if (!FirstName && LastName) {
                    fullName = LastName;
                }

                this.userInfo.DisplayName = fullName;
            }

            if (userInfo.ProfileImage) {
                this.basicUserInfo = JSON.parse(JSON.stringify(userInfo));
            }
        });

        this.currentDomain = window.location.protocol + '//' + window.location.hostname;
        this.currentDomainWithoutProtocol = window.location.hostname;
        //this.authFormLogout.nativeElement.action = this.currentDomain + '/auth?LogOff';

        if (ShellDomainProvider['api']['reportIssueMenuEnableRoles'] && ShellDomainProvider['api']['reportIssueMenuEnableRoles'].length) {
            ShellDomainProvider['api']['reportIssueMenuEnableRoles'].forEach(role => {
                if (this.userInfo && this.userInfo.Roles && this.userInfo.Roles.length && this.userInfo.Roles.indexOf(role) > -1) {
                    this.showReportIssueMenu = true;
                }
            });
        }
    }

    openMyAccountDialog() {
        this.templateAtlasSharedService.openMyAccountModal.emit(true);
    }

    openDialog() {
        this.templateAtlasSharedService.openAboutModal.emit(true);
    }

    openReportDialog() {
        this.templateAtlasSharedService.openReportModal.emit(true);
    }

    customMenuClickEvent(menuItem) {
        if (menuItem['callEvent'] && typeof menuItem['callEvent'] === 'function') {
            menuItem['callEvent']();
        }
        this.ecapBroadcastService.broadcastEventPipe(menuItem['text']);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null as any);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar opened status
     */
    toggleSidebarOpened(): void {
        this._fuseSidebarService.getSidebar('navbar').toggleOpen();
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 0);
    }

    /**
     * Toggle sidebar folded status
     */
    toggleSidebarFolded(): void {
        this._fuseSidebarService.getSidebar('navbar').toggleFold();
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 0);
    }

    public logout() {
        this.loginService.logoutFromPlatform();
        // if (ShellDomainProvider['api']['isSSo'] && isPlatformBrowser(this.platformId)) {
        //     const landingUri = ShellDomainProvider['api']['logOffLandingUri'] || ShellDomainProvider['api']['landingUri'] || this.currentDomain;
        //     const siteUrl = window.location.hostname;
        //     let ssoDomains = siteUrl;
        //     let may_access = ShellDomainProvider['api']['ssoDomains'] || localStorage.getItem('may_access');

        //     //#region //? SSO config with Ignored domain
        //     const ssoIgnoreDomains = ShellDomainProvider['api']['ssoIgnoreDomains'];
        //     if (ssoIgnoreDomains && ssoIgnoreDomains.length) {
        //         let accessDomainList = Array.isArray(may_access) ? may_access : may_access.split(',');
        //         accessDomainList = accessDomainList.filter((el: string) => !ssoIgnoreDomains.includes(el));
        //         accessDomainList = accessDomainList.filter((el: string) => siteUrl !== el);
        //         may_access = accessDomainList.join(',');
        //     }
        //     //#endregion

        //     document.cookie = 'ecap-user-roles=' + JSON.stringify([]);

        //     if (may_access && may_access !== 'undefined' && may_access !== 'null') { ssoDomains += ',' + may_access; }

        //     this.authFormLogout.nativeElement[0].value = landingUri;
        //     this.authFormLogout.nativeElement[1].value = ssoDomains;
        //     this.authFormLogout.nativeElement.submit();
        // } else {
        //     this.loginService.logoutFromPlatform();
        // }
    }
    public navRoute(r: any) {
        if (r) {
            this._router.navigate([r]);
        }
    }

    getHeaderClass(){
        if(this.fuseConfig.layout.navbar && this.fuseConfig.layout.navbar?.headerClass){
            return this.fuseConfig.layout.navbar.secondaryBackground + ' ' + this.fuseConfig.layout.navbar?.headerClass;
        }
        else return this.fuseConfig.layout.navbar.secondaryBackground;
    }
}
